 var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.money_format;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision); 

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

       if(cents == '.00'){
         cents = ''
       }
    
    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      console.log(cents);
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

    const new_defaults = {
      cartModal: '.js-ajax-cart-modal', // classname
      cartModalContent: '.js-ajax-cart-modal-content', // classname
      cartModalClose: '.js-ajax-cart-modal-close', // classname
      cartDrawer: '.js-ajax-cart-drawer', // classname
      cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
      cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
      cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
      cartOverlay: '.js-ajax-cart-overlay', // classname
      cartCounter: '.js-ajax-cart-counter', // classname
      newaddToCart: '.action_button.add_to_cart', // classname
      removeFromCart: '.js-ajax-remove-from-cart', //classname
      removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
      checkoutButton: '.js-ajax-checkout-button',
    };
    
    const cartModal = document.querySelector(new_defaults.cartModal);
    const cartModalContent = document.querySelector(new_defaults.cartModalContent);
    const cartModalClose = document.querySelector(new_defaults.cartModalClose);
    const cartDrawer = document.querySelector(new_defaults.cartDrawer);
    const cartDrawerContent = document.querySelector(new_defaults.cartDrawerContent);
    const cartDrawerClose = document.querySelector(new_defaults.cartDrawerClose);
    const cartDrawerTrigger = document.querySelector(new_defaults.cartDrawerTrigger);
    const cartOverlay = document.querySelector(new_defaults.cartOverlay);
    const cartCounter = document.querySelector(new_defaults.cartCounter);
    const newaddToCart = document.querySelectorAll(new_defaults.newaddToCart);
    let removeFromCart = document.querySelectorAll(new_defaults.removeFromCart);
    const checkoutButton = document.querySelector(new_defaults.checkoutButton);
    const htmlSelector = document.documentElement;
      
  var $ = jQuery;
    $(document).on('click', '.button-card-addtocart' ,function(event) {

      event.preventDefault();
      const formID = $(this).closest('form');
      console.log(formID)
      addProductToCart(formID);
      return false;

    });



function addProductToCart(formID) {
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: formID.serialize(),
      dataType: "json",
      success: function(data){
        addToCartOk();
      },
      error: function(err){
        addToCartFail(formID);
      }
    })
}
window.fetchcart = fetchCart();
function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart);
            checkOrphanBundleItems(cart.items)
            
            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = "<div class='empty_text'>Your shopping cart is empty.<br></div>";
                $('.psh-Cart_Footer,.psh-Topbar_Subtitle').hide();
              
              $('.psh-Topbar_Titles span,.cart-count-header').text(''+cart.item_count+'');
              $('.js-ajax-cart-drawer-content').append($('.ctm_empty_cpy_txt').clone());
              $('.js-ajax-cart-drawer-content .ctm_empty_cpy_txt').removeClass('hide');
              $('.drw-Drawer').addClass('js-empty_drawer');
              $('.psh-Footer_Subtotal-free_wrapper').hide();
            } else {
                renderCart(cart);
              $('.psh-Topbar_Titles span,.cart-count-header').text(''+cart.item_count+'');
               $('.js-ajax-cart-drawer-content .ctm_empty_cpy_txt').remove();
              $(checkoutButton).removeClass('is-hidden');
              $('.psh-Cart_Footer,.psh-Topbar_Subtitle').show();
              $('.drw-Drawer').removeClass('js-empty_drawer');
              if(cart.items_subtotal_price >= 10000){
                 $('.psh-Footer_Subtotal-free_wrapper').show();
              }else{
                 $('.psh-Footer_Subtotal-free_wrapper').hide();
              }
            }

        },
    });
}

function changeItem(line, callback) {
    const quantity = 0;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
                checkOrphanBundleItems(cart.items)
            }
        },
    });
}

function onCartUpdate(cart) {
  if(cart.item_count != 0){
    $('.cart-count-bubble').show();
    $('.cart-count-bubble').text(cart.item_count);
  }else{
    $('.cart-count-bubble').hide();
    $('.cart-count-bubble').text(cart.item_count);
  }
  setTimeout(function(){
    $('.psh-Footer_Subtotal span').html(Shopify.formatMoney(cart.items_subtotal_price, Shopify.money_format));
  },50)
}

function addToCartOk(product) {
//     cartModalContent.innerHTML = product.title + ' was added to the cart!';
//     cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
//     openAddModal();
//     openCartOverlay();
  fetchCart();
  $(".drw-Drawers, body").addClass("drw-Drawers-active");
  $(".drw-Drawer").addClass("drw-Drawer-active");
  $('.pro-form-main').show();
}

function removeProductFromCart() {
    $(cartCounter).html(Number($(cartCounter).html()) - 1);
}

function addToCartFail(form_id) {
  
//     cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
   $('.ctm_product_added_err').removeClass('ctm_product_added_err');
	$('#'+form_id).append('<p class="ctm_product_added_err">The product you are trying to add is out of stock.</p>');
    setTimeout(function(e){
	  $('.ctm_product_added_err').remove();
    },4000)
//     openAddModal();
//     openCartOverlay();
}

function renderCart(cart) {

    console.log(cart);

    clearCartDrawer();

  
    cart.items.forEach(function(item, index) {
      if (item.properties?._bundle_id && !item.properties?._bundle_parent) return

      var img = item.image;
      var origin = "//cdn.shopify.com/";
      var small_img_extension = item.image;
      var small_img_url;
      if(img != null && img != undefined){
        small_img_extension = item.image.split(origin)[1];
        if(small_img_extension.indexOf('webp') > -1){
          small_img_url = item.image;
        }else{
          small_img_url = origin + small_img_extension.split('.')[0] + '_100x.' + small_img_extension.split('.')[1];
        }
      }

      /*if(item.properties != null && propeties != ''){
        if (item.properties.hasOwnProperty('_ProductImage') && item.properties['_ProductImage'] != '') {
          small_img_url = item.properties['_ProductImage'];
        }
      }*/
      
     
      const productTitle = ' <h5 class="psh-Item_Title "><a class="psh-Item_TitleLink" href="'+ item.url +'">' + item.title + '</a></h5>';
      const productImage = '<a class="psh-Item_ImageContainer" href="'+ item.url +'"><img class="psh-Item_Image" src="' + small_img_url + '" ></a>';
      var prod_variant ='';
      var properties_html = '';
      var propeties = item.properties;
      if(propeties != null && propeties != ''){
        const properties_keys = Object.keys(propeties);
        properties_keys.forEach(function(key) {
          if (propeties[key] != '' && key.charAt(0) != '_') {
            if (key == 'preorder_text') {
              var property_html = `<div class="item-property">${propeties[key]}</div>`;
              properties_html += property_html;
            } else {
              var property_html = `<div class="item-property">${key}: ${propeties[key]}</div>`;
              properties_html += property_html;            
            }
          }
        });  
      }
      
      if(item.options_with_values[0].value != 'Default Title'){
       prod_variant = '<div class="ctm_selected_variant">'+item.options_with_values[0].name+': <span>'+item.options_with_values[0].value+'</span></div>'
       }
      var selling_html='';
      if(item.selling_plan_allocation != undefined){
       selling_html += '<div class="selling_plan"><span>'+item.selling_plan_allocation.selling_plan.name+'</span></div>';
      }
      let isBundleParent = false
      let bundleChildProducts = ''
      let itemPrice = item.price
      if(item.properties?._bundle_parent) {
        const matchingChildProducts = cart.items.filter((allItem) => (allItem.properties?._bundle_id == item.properties?._bundle_id) && !allItem.properties?._bundle_parent)
        const childBundleList = [...matchingChildProducts].map((item) => {
          const itemCount = matchingChildProducts.reduce((sum, setItem) => sum + (item.product_title == setItem.product_title ? setItem.quantity : 0), 0)
          return `<li>${itemCount}x ${item.product_title}</li>
        `})
        bundleChildProducts = `<ul class="cart-drawer__child-bundles">${childBundleList.join('')}</ul>`
        
        isBundleParent = true
        itemPrice = matchingChildProducts.reduce((sum, item) => sum + (item.original_price * item.quantity), 0);
      }

      const productPrice = ' <p class="psh-Item_Price fz-1320"><span class="money">' + Shopify.formatMoney(itemPrice, Shopify.money_format) + '</span></p>';
      var productQuantity = selling_html+bundleChildProducts+'<div class="psh-Item_Controls flex align-item-center space-between"  data-line="' + Number(index + 1) + '"><div class="psh-Quantity">';
      productQuantity +=   '<div class="product-quantity-box flex align-item-center justify-center"><button class="psh-Quantity_Button psh-Quantity_Decrease product-minus js-change-quantity"  data-func="minus"><span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 6H9.5" stroke="#343245" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button><input type="text" min="0" class="psh-Quantity_Value fz-1417 quantity" name="updates[]" id="updates_'+item.id+'" value="'+item.quantity+'" data-cart-quantity-input="mini-cart"><button class="psh-Quantity_Button psh-Quantity_Increase product-plus js-change-quantity" data-func="plus"><span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2.5V9.5" stroke="#343245" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.5 6H9.5" stroke="#343245" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button></div></div>'
      productQuantity += '<div class="ajax-cart-item__remove ' + new_defaults.removeFromCartNoDot + '"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6H5H21" stroke="#343245" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#343245" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 11V17" stroke="#343245" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 11V17" stroke="#343245" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +'</div>';
      var html = ' <li class="psh-Body_Item" data-cart-form="mini-cart" data-cart-item data-line-id="' + Number(index + 1) + '" data-variant-id="'+item.id+'"><div class="ajax-cart-item__single psh-Item flex">'
      const concatProductInfo = html + productImage + '<div class="psh-Item_Content"><div class="content flex space-between">' +  productTitle 
//       + prod_variant 
     +productPrice +'</div>' 
      + properties_html + productQuantity + '</div></div>' ;
      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;
      cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + '</div></li>'

    });
  
    removeFromCart = document.querySelectorAll(new_defaults.removeFromCart);
//     $('.psh-Footer_Subtotal span').text(Shopify.formatMoney(cart.items_subtotal_price, Shopify.money_format));
    for (let i = 0; i < removeFromCart.length; i++) {
      removeFromCart[i].addEventListener('click', function() {
        const line = $(this).closest('.psh-Body_Item').attr('data-line-id'); 
        changeItem(line);
      });
    }
    
  

    // document.querySelectorAll('.js-ajax-remove-from-cart')
    //     .forEach((element) => {
    //         element.addEventListener('click', function() {
    //             const lineID = this.parentNode.getAttribute('data-line');
    //             console.log('aa');
    //         });
    //     });

   
 
}

function openCartDrawer() {
    cartDrawer.classList.add('is-open');
}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
}

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}


document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});


$('body').on('change', '[data-cart-quantity-input]', function() {
  var cartItem = {
    lineID: $(this).parents('[data-cart-item]').data('line-id'),
    variantID: $(this).parents('[data-cart-item]').data('variant-id'),
    quantity: $(this).val(),
    parentCartForm: $(this).parents('[data-cart-form]'),
    totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
    $element : $(this).parents('[data-cart-item]')
  }
  // Disable button after click to prevent multiple clicks
  $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
  updateCartItemQuantity(cartItem);
});

$('body').on('click', '.js-change-quantity', function() {
  var $this = $(this),
      $input = $(this).siblings('input'),
      val = parseInt($input.val()),
      valMax = 100000000000000000000000000000,
      valMin = $input.attr('min') || 0;

  if ($input.attr('max') != null){
    valMax = $input.attr('max');
  }

  if(isNaN(val) || val < valMin) {
    $input.val(valMin);
    return false;
  } else if (val > valMax) {
    $input.val(valMax);
    return false;
  }

  if($this.data('func') == 'plus') {
    if(val < valMax) $input.val(val + 1);
  } else {
    if(val > valMin) $input.val(val - 1);
    if($this.parents(".cart_item").length) {
      if (val - 1 == 0) {
        $this.closest('.cart_item').addClass('animated fadeOutUp')
      }
    }
  }
  $input.trigger('change');

});

function updateCartItemQuantity(cartItem) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: {
      quantity: cartItem.quantity,
      line: cartItem.lineID
    },
    success: function (data) {
      console.log(data)
      console.log(cartItem.quantity,cartItem.lineID);
      
      $('.js-ajax-cart-counter').text(data.item_count);

      var cartItemsArray = data.items;
      var lineIDIndex = cartItem.lineID - 1;
      var totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
      var $quantityInputs = cartItem.parentCartForm.find('[data-variant-id="' + cartItem.variantID + '"] input');
      var initialQuantityTotal = 0;
      var apiQuantityTotal = 0;
      var apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

      checkOrphanBundleItems(cartItemsArray)

      // Check if item has a "Buy X get Y" deal
      if ($quantityInputs.length > 1) {
        // Multiple inputs

        // Get all the quantities of same variants in the cart (including BOGO) in HTML
        $.each($quantityInputs, function (i, input) {
          initialQuantityTotal += parseInt($(input).val());
        });

        // Get quantities from cart object returned from API
        cartItemsArray.forEach(function (item) {
          if (item.variant_id === cartItem.variantID) {
            apiQuantityTotal += item.quantity;
          }
        })
      } else {
        // Single input
        initialQuantityTotal = parseInt($quantityInputs.val());
        apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
      }

      //Checks to see if there is enough inventory to update to an increased amount
      if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {            

        //Check if Buy one get one product
        if (totalCartItems < cartItemsArray.length) {
          fetchCart();
        } 

      }else {

        fetchCart();
      }

    },
    error: function(err){
      console.log('test 123456')
    }
  });
}

  checkOrphanBundleItems = (lineItems) => {
    if (!lineItems || lineItems.length <= 0) return;

    let bundleItems = [...lineItems].map((item) => item?.properties?._bundle_id);
    let bundleIDs = bundleItems.filter((id) => id);
    let orphanBundleIDs = [];
    if (!bundleIDs || bundleIDs.length <= 0) return;

    bundleIDs.forEach((bundleID) => {
      let bundleMin = 0;
      let bundleMax = 0;
      let bundleCount = 0;
      const hasChildProduct = lineItems.filter((item) =>
        item.properties?._bundle_id == bundleID && !item?.properties?._bundle_parent,
      );
      const hasParentProduct = lineItems.find( (item) =>
        item.properties?._bundle_id == bundleID && item?.properties?._bundle_parent === true,
      );

      if (!hasChildProduct || hasChildProduct.length <= 0 || !hasParentProduct) {
        orphanBundleIDs.push(bundleID);
        return;
      }

      bundleMin = parseInt(hasParentProduct.properties?._bundle_min) || bundleMin;
      bundleMax = parseInt(hasParentProduct.properties?._bundle_max) || bundleMax;

      bundleCount = hasChildProduct.reduce((acc, item) => acc + parseInt(item.quantity), 0) || bundleCount;
      if (bundleCount < bundleMin || bundleCount > bundleMax) {
        orphanBundleIDs.push(bundleID);
      }
    });

    if (orphanBundleIDs.length <= 0) return;

    this.deleteOrphanBundleProducts(lineItems, orphanBundleIDs);
  };

  /**
   * Removes all unlinked bundle products
   * @param {Array} cart - Cart line items
   * @param {Array} orphanBundleIDs - Array of unlinked products to delete
   */
  function deleteOrphanBundleProducts(cart, orphanBundleIDs) {
    const { Rebuy } = window;
    let orphanData = {
      updates: {},
    };
    orphanBundleIDs.forEach((bundleID) => {
      cart.map((item) => {
        if (!item || item?.properties?._bundle_id !== bundleID) {
          return;
        }

        orphanData["updates"][String(item.key)] = 0;
      });
    });

    fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      body: JSON.stringify(orphanData),
    })
      .then((response) => {
        if (!Rebuy) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error("Error removing bundle product from cart:", error);
      });
  }



$('.account-drawer-close').on('click',function(e){
  if($('body').hasClass('active-sidebar')){
    $('body').removeClass('active-sidebar');
  }
})

$("#cartTotal").on('click',function(e){
  e.preventDefault();
  $(".drw-Drawers, body").addClass("drw-Drawers-active");
  $(".drw-Drawer").addClass("drw-Drawer-active");
  var topContent = Math.max($('[data-body-wrap]').offset().top, 60);
  if ($(window).scrollTop() < topContent) {
    $('[data-section-type="header"]').addClass('header--has-scrolled');
    $('[data-section-type="header"]').removeClass('header--transparent');
  }
  return false;
});

$(".psh-TopBar_Close, .drw-Drawers_Backdrop").on('click',function(){
  $(".drw-Drawers, body").removeClass("drw-Drawers-active");
  $(".drw-Drawer").removeClass("drw-Drawer-active");
  var topContent = Math.max($('[data-body-wrap]').offset().top, 60);
  if ($(window).scrollTop() < topContent) {
    $('[data-section-type="header"]').removeClass('header--has-scrolled');
    if (window.isHeaderTransparent) {
      $('[data-section-type="header"]').addClass('header--transparent');
    }
  }
});

var url = window.location.href;
if(url.indexOf('/products') > -1){
    // Select the node that will be observed for mutations
  var targetNode = document.querySelector('body');
  
  // Options for the observer (which mutations to observe)
  var config = { attributes: true, childList: true, subtree: true };
  
  // Callback function to execute when mutations are observed
  var callback = (mutationList, observer_1) => {
    var len = $('.zrx-sticky-atc-just-added-bar').length;
    if(len > 0){
      if(window.g_count == 0){
        window.fetchCart();
        setTimeout(function(e) {
          $('#cartTotal-click')[0].click();
        },500) 
        window.g_count = 999;
      }
    }
  };
   
  // Create an observer instance linked to the callback function
  var observer_1 = new MutationObserver(callback);
  
  // Start observing the target node for configured mutations
  observer_1.observe(targetNode, config);

  $(document).on('click','.zrx-sticky-atc-main-button',function(e) {
    window.g_count = 0;
  })
  
}

if (window.location.pathname.includes('/products/')) window.stayAIBundleHelpers = []
const isStayAIBundle = window.stayAIBundleHelpers || false;
if ( isStayAIBundle) {
  window.stayAIBundleHelpers = { 
    onAddToCart: () => { 
      $('[data-add-to-cart], .add-cart-sticky-desktop').removeAttr('disabled');
      addToCartOk();
    } 
  }
}

$('#hamburger-menu').on('click',function(e) {
   $(".drw-Drawers, body").removeClass("drw-Drawers-active");
  $(".drw-Drawer").removeClass("drw-Drawer-active");
})

$('.header__icons #cartTotal').on('click',function(e){
   var len = $('.header__icons a[aria-expanded="true"] .defult-menu-close').length ; 
   if(len > 0){
     $('.header__icons a[aria-expanded="true"] .defult-menu-close')[0].click();      
   }
  
})
